var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 2.00006C9.23851 2.00006 6.99994 4.23864 6.99994 7.00006C6.99994 9.76149 9.23851 12.0001 11.9999 12.0001C14.7614 12.0001 16.9999 9.76149 16.9999 7.00006C16.9999 4.23864 14.7614 2.00006 11.9999 2.00006Z",
    fill: "#4f4c57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.0001C6.67392 14.0001 5.40215 14.5268 4.46447 15.4645C3.52678 16.4022 3 17.674 3 19.0001V21.0001C3 21.5523 3.44772 22.0001 4 22.0001H20C20.5523 22.0001 21 21.5523 21 21.0001V19.0001C21 17.674 20.4732 16.4022 19.5355 15.4645C18.5979 14.5268 17.3261 14.0001 16 14.0001H8Z",
    fill: "#4f4c57"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.62cd7457f357cd244b92cc14406d3a2d.svg";
export { ForwardRef as ReactComponent };